import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  Table,
  CustomInput,
} from 'reactstrap'
import get from 'lodash/get'
import find from 'lodash/find'
import shortid from 'shortid'
import ReactList from 'react-list'
import styled from 'styled-components'

class AddResourceForm extends React.Component {
  state={ tempSearch: '' }

  filterResource = (element) => {
    const resource_search = get(this.props, 'resource_search', '')
    if (resource_search && element) {
      const label = element.label.toLowerCase()
      const lob = element.lob.toLowerCase()
      const department = element.department.toLowerCase()
      return label.includes(resource_search.toLowerCase())
      || lob.includes(resource_search.toLowerCase())
      || department.includes(resource_search.toLowerCase())
    } return element
  }

  renderResourceName = () => {
    const employees = get(this.props, 'employees', [])
    const resources = get(this.props, 'resources', [])
    const list = []
    employees.map(emp => {
      const res = find(resources, {
        user_id: emp._id,
      })
      if (res === undefined && (get(this.props, 'type') === 'Subcontract' ? emp.employee_type === 'Subcontract' : emp.employee_type !== 'Subcontract')) {
        if (emp.is_active) {
          list.push({
            label: `${emp.emp_code} - ${emp.first_name} ${emp.last_name} (${emp.nick_name})`,
            value: emp._id,
            _id: emp._id,
            lob: emp.lob,
            department: emp.department,
            type: emp.employee_type,
          })
        }
      }
      return null
    })
    return list
  }

  renderItem = (index) => {
    const resources = this.renderResourceName().filter(this.filterResource)
    const resource_user_id = get(this.props, 'resource_user_id')
    const handleInput = get(this.props, 'handleInput')
    const res = resources[index]
    return (
      <tr key={ shortid() }>
        <td style={ { width: '50%' } }>
          <CustomCheckboxInput
            id={ shortid() }
            type="checkbox"
            name='addResource'
            label={ res.label }
            value={ res._id }
            checked={ resource_user_id.includes(res._id) }
            onChange={ handleInput }
          />
        </td>
        <td>{ res.lob }</td>
        <td>{ res.department }</td>
      </tr>
    )
  }

  render() {
    const open = get(this.props, 'open')
    const type = get(this.props, 'type')
    const toggle = get(this.props, 'toggle')
    const resources = this.renderResourceName().filter(this.filterResource)
    // const resource_user_id = get(this.props, 'resource_user_id')
    const handleSearch = get(this.props, 'handleSearch')
    const handleClickAll = get(this.props, 'handleClickAll')
    const handleClickNone = get(this.props, 'handleClickNone')
    // const handleInput = get(this.props, 'handleInput')
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        size='lg'
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <ModalHeader toggle={ () => toggle() }>
          <HeadLabel>{ `Add ${type} Resources` }</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container >
                    <Row>
                      <Col>
                        <SearchField
                          onChange={ (e) => {
                            if (e.target.value === '') handleSearch(e.target.value)
                            this.setState({ tempSearch: e.target.value })
                          } }
                          onKeyDown={ (e) => {
                            if (e.keyCode === 13) handleSearch(this.state.tempSearch)
                          } }
                          placeholder={ 'Search name, lob or department' }
                        />
                        <TypeLabel>&nbsp;{`(Selected ${get(this.props, 'resource_user_id.length', 0)})`}&nbsp;
                        </TypeLabel>
                        <ClickableText
                          onClick={ () => handleClickAll(resources) }
                        >SELECT All</ClickableText>
                        <ClickableText
                          onClick={ () => handleClickNone() }
                        >RESET</ClickableText>
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col>
                        <TableDiv>
                          <NewTable bordered /* hover */>
                            <Header>
                              <tr style={ { fontFamily: 'Gotham' } }>
                                <th style={ { width: '50%' } }>Name</th>
                                <th>LOB</th>
                                <th>Department</th>
                              </tr>
                            </Header>
                            <BodyTable>
                              <ReactList
                                itemRenderer={ this.renderItem }
                                length={ resources.length }
                                // type='variable'
                              />
                            </BodyTable>
                          </NewTable>
                        </TableDiv>
                      </Col>
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          { get(this.props, 'button') }
        </ModalFooter>
      </Modal>
    )
  }
}

export default AddResourceForm

const HeadLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    color: #AD2624;
`
const TypeLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
`
const SearchField = styled.input`
  font-family: 'Gotham' !important;
  width: 40%;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: auto;
  box-sizing: border-box;
  padding-left:2%;
`
const BodyTable = styled.tbody`
    @media (max-width: 575.98px) {
      max-height: calc(100vh - 300px);
    }
    @media (max-width: 767.98px) {
      max-height: calc(100vh - 300px);
    }
    width: 100% ;
    display: block ;
    max-height: calc(100vh - 500px);
    overflow-y:scroll;
    ::-webkit-scrollbar {
      -webkit-appearance: none;
    }
    ::-webkit-scrollbar:vertical {
      width: 11px;
    }
    ::-webkit-scrollbar:horizontal {
      height: 11px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 8px;
      border: 2px solid white; /* should match background, can't be transparent */
      background-color: rgba(0, 0, 0, .5);
    }
`
const TableDiv = styled.div`
    font-family: 'Gotham'!important;
    @media (max-width: 575.98px) {
      padding-right: 0px;
      padding-left: 0px;
      font-size: 12px;
      width:100%;
      overflow:scroll;
    }
    @media (max-width: 767.98px) {
      padding-right: 0px;
      padding-left: 0px;
      font-size: 12px;
      width:100%;
      overflow:scroll;
    }
`

const NewTable = styled(Table)`
    background: white;
    thead, tbody tr{
      display:table;
      width:100%;
      table-layout:fixed;
    }thead th{
      background: #404040;
      border: none;
      font-family: 'Gotham-Bold' !important;
      font-size: 14px ;
    }tbody td{
      font-family: 'Gotham' !important;
      border: none;
      font-size: 12px ;
    }
    @media (max-width: 575.98px) {
      width:800px;
    thead, tbody tr{
      display:table;
      width:100%;
      table-layout:fixed;
    }
    td {
      padding-left: 1%;
    }
    th {
        padding-left: 1% ;
      }
    }
    @media (max-width: 767.98px) {
      width:800px;
    td {
      padding-left: 1%;
    }
    th {
      padding-left: 1% ;
    }
  }
  @media (max-width: 991.98px) {
      width:800px;
    td {
      padding-left: 1%;
    }
    th {
      padding-left: 1% ;
    }
    }
`
const Header = styled.thead`
  background: black;
  color: white;
  font-family: 'Gotham-Bold' !important;
  font-weight: lighter !important;
`
const CustomCheckboxInput = styled(CustomInput)`
  font-family: 'Gotham' !important;
  font-size: 12px;
`
const ClickableText = styled.span`
    cursor: pointer;
    font-family: 'Gotham-Bold' !important;
    border: 1px solid #CCCCCC;
    border-radius: 5px;
    padding: 10px ;
    float: right;
    margin-left: 2%;
    &:hover{
      background-color: #EEEEEE;
    }
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/add-resource/index.js